import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['finance-oss'], // 为了获取基础路由
    };
};
export const financeOssToPathNameMap = {
    // 运营子系统订单详情页（保险订单
    finance8006: ({ businessKey }) => commonFunc(`/order/insuranceOrder/detail?id=${businessKey}`),
    // 运营子系统合作渠道机构待处理列表
    finance8007: () => commonFunc(`/channel/channelOrg`),
    // 运营子系统合作渠道产品未关联列表
    finance8009: () => commonFunc(`/channel/channelProduct`),
    // 运营子系统订单详情页（融资订单
    finance8011: ({ businessKey }) => commonFunc(`/order/financingOrder/detail?id=${businessKey}`),
};
